<template>
  <div>
    <nav class="navbar navbar-default">
      <div v-if="!websiteAvailability.canTakeOrders || !websiteAvailability.isOpen" class="is-closed-alert">
        <i class="fa fa-exclamation-circle"></i>
        We are sorry but we do not take orders at this moment.
        {{ websiteAvailability.canTakeOrders && !websiteAvailability.isOpen ? `Come back please${websiteAvailability.nextOpeningDay ? ' on ' + websiteAvailability.nextOpeningDay : ''} at ${websiteAvailability.nextOpeningHour}` : '' }}
      </div>
      <div v-if="location && location.id === 2 && $route.name !== 'select-location'" class="info-popup">
        <div class="info-popup-content">
          <closed-location-notice>
            <div class="change-location-link" @click="changeLocation">Change location</div>
          </closed-location-notice>
        </div>
      </div>
<!--      <div v-else-if="location && location.id === 2" class="information-alert">-->
<!--        <i class="fa fa-info-circle"></i>-->
<!--        Unfortunately, currently we are experiencing land line failure. Please use <u>074 4570 0291</u> if you need to contact the shop. Thank you and we are sorry for the inconvenience.-->
<!--      </div>-->
<!--      <div v-if="location && location.id === 2 && informationPopupOpened" class="info-popup">-->
<!--        <div class="info-popup-content">-->
<!--          <svg id="Layer_3" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m45 3h-4-1c-1.105 0-2 .895-2 2s-.895 2-2 2h-8c-1.105 0-2-.895-2-2s-.895-2-2-2h-1-4c-2.761 0-5 2.239-5 5v48c0 2.761 2.239 5 5 5h26c2.761 0 5-2.239 5-5v-48c0-2.761-2.239-5-5-5z" fill="#004fa8"/><path d="m44 57h-24c-1.105 0-2-.895-2-2v-46c0-1.105.895-2 2-2h24c1.105 0 2 .895 2 2v46c0 1.105-.895 2-2 2z" fill="#f2f8ff"/><path d="m26 5c0 1.105.895 2 2 2h8c1.105 0 2-.895 2-2s.895-2 2-2h-16c1.105 0 2 .895 2 2z" fill="#004fa8"/><path d="m46 20-5 3.651-5-3.651v-9c-2.986 1.73-5 4.952-5 8.651 0 4.477 2.943 8.266 7 9.541v24.808h8z" fill="#57a5ff"/><path d="m30.891 41.364 4.109-.864v-5l-4.109-.864c-.874-.184-1.279-1.198-.772-1.933l2.381-3.453-3.75-3.75-3.454 2.381c-.735.507-1.749.102-1.933-.772l-.863-4.109h-4.5v9.341.007c.626-.221 1.298-.348 2-.348 3.314 0 6 2.686 6 6s-2.686 6-6 6c-.702 0-1.374-.127-2-.349v.007 9.342h4.5l.864-4.109c.184-.874 1.198-1.279 1.933-.772l3.453 2.381 3.75-3.75-2.381-3.454c-.506-.735-.101-1.749.772-1.932z" fill="#57a5ff"/><g fill="#f2f8ff"><path d="m33 19.651c0-2.794 1.151-5.313 3-7.126v-1.525c-2.986 1.73-5 4.952-5 8.651 0 4.477 2.943 8.266 7 9.541v24.808h2v-24.808c-4.057-1.274-7-5.063-7-9.541z"/><path d="m18 43.651v.007.342c.34 0 .67-.035.995-.089-.342-.06-.675-.146-.995-.26z"/><path d="m23.296 27.881.332-.229c-.126-.15-.22-.332-.265-.543l-.863-4.109h-2l.864 4.109c.183.873 1.197 1.278 1.932.772z"/><path d="m18.995 32.089c-.325-.054-.655-.089-.995-.089v.341.007c.32-.113.653-.199.995-.259z"/><path d="m30.891 41.364 4.109-.864v-5l-4.109-.864c-.874-.184-1.279-1.198-.772-1.933l2.381-3.453-3.75-3.75-1.184.816 2.934 2.934-2.381 3.454c-.507.735-.102 1.749.772 1.933l4.109.863v5l-4.109.864c-.874.184-1.279 1.198-.772 1.933l2.381 3.453-2.934 2.934 1.184.816 3.75-3.75-2.381-3.454c-.506-.735-.101-1.749.772-1.932z"/><path d="m23.296 48.119c-.735-.507-1.749-.102-1.933.772l-.863 4.109h2l.864-4.109c.044-.211.139-.393.265-.543z"/></g><path d="m48.649 59.398c-17.46-6.239-30.539-21.261-34.13-39.729l-.519-2.669v39c0 2.761 2.239 5 5 5h26c1.445 0 2.737-.622 3.649-1.602z" fill="#303030" opacity=".12"/><path d="m45 2h-4-1-16-1-4c-3.309 0-6 2.691-6 6v48c0 3.309 2.691 6 6 6h26c3.309 0 6-2.691 6-6v-48c0-3.309-2.691-6-6-6zm-7.816 2c-.112.314-.184.648-.184 1 0 .552-.448 1-1 1h-8c-.552 0-1-.448-1-1 0-.352-.072-.686-.184-1zm11.816 52c0 2.206-1.794 4-4 4h-26c-2.206 0-4-1.794-4-4v-48c0-2.206 1.794-4 4-4h4 1c.552 0 1 .448 1 1 0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3 0-.552.448-1 1-1h1 4c2.206 0 4 1.794 4 4z"/><path d="m19 9c0-.552.448-1 1-1h2v-2h-2c-1.654 0-3 1.346-3 3v5h2z"/><path d="m44 6h-2v2h2c.552 0 1 .448 1 1v10.492l-4 2.921-4-2.921v-8.492c0-.357-.19-.688-.501-.866-.309-.178-.691-.179-1 .001-3.392 1.964-5.499 5.61-5.499 9.516 0 4.581 2.783 8.611 7 10.249v4.1h2v-4.808c0-.437-.283-.823-.7-.954-3.769-1.184-6.3-4.635-6.3-8.587 0-2.571 1.117-5.005 3-6.695v7.044c0 .319.152.619.41.808l5 3.651c.352.256.828.256 1.18 0l3.41-2.49v33.031c0 .552-.448 1-1 1h-24c-.552 0-1-.448-1-1v-1h3.5c.473 0 .882-.331.979-.794l.863-4.108c.022-.109.096-.159.152-.182s.142-.037.234.026l3.454 2.381c.396.275.934.225 1.274-.116l3.75-3.75c.341-.341.391-.877.116-1.274l-2.381-3.455c-.063-.09-.049-.177-.026-.233s.072-.13.182-.152l4.108-.863c.464-.098.795-.507.795-.98v-5c0-.473-.331-.882-.794-.979l-4.108-.863c-.109-.022-.159-.096-.182-.152s-.036-.144.026-.234l2.381-3.454c.274-.397.225-.934-.116-1.274l-3.75-3.75c-.341-.342-.878-.392-1.274-.116l-3.455 2.381c-.09.063-.177.05-.233.026-.057-.022-.13-.072-.152-.182l-.863-4.108c-.098-.464-.507-.795-.98-.795h-3.5v-6h-2v39c0 1.654 1.346 3 3 3h24c1.654 0 3-1.346 3-3v-46c0-1.654-1.346-3-3-3zm-22.312 18 .696 3.314c.155.738.667 1.347 1.368 1.627.7.279 1.492.191 2.11-.237l2.769-1.908 2.572 2.572-1.908 2.768c-.429.621-.518 1.41-.237 2.111s.889 1.213 1.627 1.368l3.315.697v3.377l-3.314.696c-.738.155-1.347.667-1.627 1.368s-.191 1.49.237 2.11l1.908 2.769-2.572 2.572-2.768-1.908c-.621-.427-1.411-.516-2.111-.237-.701.28-1.213.889-1.368 1.627l-.697 3.314h-2.688v-7.085c.33.048.662.085 1 .085 2.491 0 4.814-1.341 6.063-3.499l-1.73-1.002c-.894 1.543-2.554 2.501-4.333 2.501-.34 0-.672-.044-1-.111v-9.783c1.28-.256 2.663-.006 3.764.727l1.107-1.666c-1.429-.95-3.191-1.318-4.871-1.083v-7.084z"/><path d="m27 38c0-1.23-.324-2.441-.938-3.501l-1.73 1.002c.437.756.668 1.62.668 2.499z"/><path d="m37 36h2v18h-2z"/></svg>-->

<!--          <h3>Important Information!</h3>-->

<!--          <p>We are experiencing BT landline failure at the moment, Please use <strong><u>07445700291</u></strong> if you need to contact the shop.</p>-->
<!--          <p>Online Ordering is still the best way to place your order.</p>-->

<!--          <div class="close-info-popup" @click="closeInfoPopup">×</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="container-fluid">
        <div class="navbar-header">
          <div class="responsive-top-cart">
            <a href="#" class="btn-rotate" @click="showCart = !showCart">
              <span class="cart">
                <span v-if="cart.length > 0" class="cart-counter">{{ cart.length }}</span>
                <i class="ti-shopping-cart"></i>
              </span>
              <p>
                £{{ getCartTotal.toFixed(2) }}
              </p>
            </a>
          </div>
          <button type="button" class="navbar-toggle" @click="toggleMenuVisible = !toggleMenuVisible">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar bar1"></span>
            <span class="icon-bar bar2"></span>
            <span class="icon-bar bar3"></span>
          </button>
          <router-link to="/" tag="a" ref="homepage" class="kf-logo">
            <img src="../../assets/img/KF-logo-white.png" alt="Kungfood Logo" />
          </router-link>
          <div class="location">
            <i class="fa fa-map-marker"></i>
            <span id="locationName" title="Change Location" @click="changeLocation">{{ locationName }}</span>
          </div>
        </div>
        <div :class="[toggleMenuVisible ? 'visible' : '', 'navbar-right-menu']">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/" tag="li" ref="homepage" v-on:click.native="toggleMenuVisible = false">
              <a class="btn-rotate">
                <p>
                  Homepage
                </p>
              </a>
            </router-link>
            <router-link to="/menu" tag="li" ref="menu" v-on:click.native="toggleMenuVisible = false">
              <a class="btn-rotate">
                <p>
                  Menu
                </p>
              </a>
            </router-link>
            <router-link to="/lunch-boxes" tag="li" ref="lunchBoxes" v-on:click.native="toggleMenuVisible = false">
              <a class="btn-rotate">
                <p>
                  Lunch Boxes
                </p>
              </a>
            </router-link>
            <router-link to="/contact" tag="li" ref="contact" v-on:click.native="toggleMenuVisible = false">
              <a class="btn-rotate">
                <p>
                  Contact
                </p>
              </a>
            </router-link>
            <!--<router-link to="catering" tag="li" ref="contact">-->
            <!--<a class="btn-rotate">-->
            <!--<p>-->
            <!--Catering Services-->
            <!--</p>-->
            <!--</a>-->
            <!--</router-link>-->
            <router-link to="/profile" tag="li" ref="profile" v-on:click.native="toggleMenuVisible = false">
              <a class="btn-rotate">
                <p>
                  {{ user ? 'Profile' : 'Sign in' }}
                </p>
              </a>
            </router-link>
            <li class="cart">
              <a href="#" class="btn-rotate" @click="showCart = !showCart">
              <span class="cart">
                <span v-if="cart.length > 0" class="cart-counter">{{ cart.length }}</span>
                <i class="ti-shopping-cart"></i>
              </span>
                <p>
                  £{{ getCartTotal.toFixed(2) }}
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <CartPopup :show-cart="showCart" @closeShowCart="closeShowCart"></CartPopup>
    </nav>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import CartPopup from '../cart-popup.vue'
  import Notification from 'src/components/UIComponents/NotificationPlugin/Notification.vue'
  import ClosedLocationNotice from '../closed-location-notice.vue'
  import ls from 'local-storage'

  let kf
  let checkCustomerInterval = null

  export default {
    name: 'top-navbar',
    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user,
        location: state => state.location,
        cart: state => state.cart,
        websiteAvailability: state => state.websiteAvailability
      }),
      ...mapGetters({
        getLocation: 'getLocation',
        getCartTotal: 'getCartTotal',
        infoPopupOpened: 'infoPopupOpened'
      })
    },
    data () {
      return {
        locationName: 'Not Selected',
        showCart: null,
        toggleMenuVisible: false,
        informationPopupOpened: false
      }
    },
    created () {
      if (!this.location) {
        this.$router.push({ name: 'select-location' })
      } else {
        this.locationName = this.getLocation(this.location.id).name
      }
    },
    mounted () {
      console.log(this.infoPopupOpened)
      this.informationPopupOpened = Boolean(this.infoPopupOpened)
      this.$store.dispatch('GetSettings', this.location.id)

      if (this.token) {
        checkCustomerInterval = setInterval(function () {
          kf.checkForCustomer()
        }, 30000)
      }

      kf = this
    },
    methods: {
      changeLocation: () => {
        kf.$router.push({ name: 'select-location' })
      },
      closeShowCart: () => {
        kf.showCart = false
      },
      closeInfoPopup: () => {
        kf.informationPopupOpened = false
        ls.set('infoPopupOpened', false)
      },
      checkForCustomer: () => {
        if (kf.user) {
          kf.$store.dispatch('GetStatus')
            .catch(() => {
              kf.notifyVue('danger', 'An error has been produced and you were logged off. Please try to authenticate back.')
              clearInterval(checkCustomerInterval)
              checkCustomerInterval = null
              kf.$store.dispatch('AuthSignout')
            })
        } else {
          clearInterval(checkCustomerInterval)
          checkCustomerInterval = null
        }
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    },
    watch: {
      '$route': function () {
        kf.checkForCustomer()

        if (!checkCustomerInterval) {
          checkCustomerInterval = setInterval(function () {
            kf.checkForCustomer()
          }, 30000)
        }
      }
    },
    components: {
      CartPopup,
      Notification,
      ClosedLocationNotice
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// TopNavbar.vue?8cbe4572